<template>
  <div class="home">
    <v-progress-linear
      :active="isLoadingHomePageItems"
      :indeterminate="isLoadingHomePageItems"
      absolute
      top
      color="#743063"
    ></v-progress-linear>
    <v-card max-width="1650" elevation="1" class="mx-auto">
      <v-responsive :aspect-ratio="1000 / 418">
        <v-carousel height="auto" cycle hide-delimiters :show-arrows="false">
          <v-carousel-item
            @click.native="homeBannerItemClicked(item)"
            v-for="(item, i) in homeBanner.bannarItems"
            :key="i"
            :src="item.imageUrl | localized"
          >
          </v-carousel-item>
        </v-carousel>
      </v-responsive>
    </v-card>

    <div class="hidden-sm-and-down">
      <v-card class="d-flex flex-wrap mx-auto my-1" flat max-width="1650">
        <ItemComponent
          v-for="item in homePageItems"
          :key="item.id"
          :itemProp="item"
        ></ItemComponent>
      </v-card>
    </div>
    <div class="hidden-md-and-up">
      <div class="d-flex flex-column align-center">
        <ItemComponent
          v-for="item in homePageItems"
          :key="item.id"
          :itemProp="item"
        ></ItemComponent>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ItemComponent from "@/components/ItemComponent";
export default {
  name: "Home",

  //********************** */
  components: {
    ItemComponent,
  },

  //********************** */
  data: () => ({
    isLoadingHomePageItems: false,
    showError: false,
  }),

  //********************** */
  computed: {
    ...mapGetters("Catalog", {
      homeBanner: "homeBanner",
      homePageItems: "homePageItems",
    }),
  },

  //********************** */
  methods: {
    loadHomeBanner: async function () {
      await this.$store.dispatch("Catalog/loadHomeBanner");
    },

    homeBannerItemClicked: function (item) {
      if (item.destinationType == "Category") {
        let destinationOutlineId = item.destinationOutlineId;
        this.$router.push({ path: `/category/${destinationOutlineId}` });
      }

       if (item.destinationType == "Item") {
        let destinationOutlineId = item.destinationOutlineId;
        this.$router.push({ path: `/itemDetail/${destinationOutlineId}` });
      }

      if (item.destinationType == "Url") {
        let destinationUrl = item.url;
        if (!destinationUrl) {
          alert("Destination URL is not set for this banner item.");
          return;
        }
        window.location.href = destinationUrl;
      }
    },

    loadHomePageItems: async function () {
      this.isLoadingHomePageItems = true;
      try {
        await this.$store.dispatch("Catalog/loadHomePageItems");
      } catch (error) {
        setTimeout(() => (this.showError = false), 3000);
      }

      this.isLoadingHomePageItems = false;
    },
  },

  //*********************** */
  async mounted() {
    await this.loadHomeBanner();
    await this.loadHomePageItems();
    //this.$gtag.event('home', { method: 'Google' })
  },
};
</script>

<style>
</style>